/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TestIntegrationResponse
 */
export interface TestIntegrationResponse {
  /**
   *
   * @type {boolean}
   * @memberof TestIntegrationResponse
   */
  ok: boolean;
  /**
   *
   * @type {number}
   * @memberof TestIntegrationResponse
   */
  statusCode: number;
  /**
   *
   * @type {string}
   * @memberof TestIntegrationResponse
   */
  responseBody: string;
}

/**
 * Check if a given object implements the TestIntegrationResponse interface.
 */
export function instanceOfTestIntegrationResponse(
  value: object,
): value is TestIntegrationResponse {
  if (!("ok" in value) || value["ok"] === undefined) return false;
  if (!("statusCode" in value) || value["statusCode"] === undefined)
    return false;
  if (!("responseBody" in value) || value["responseBody"] === undefined)
    return false;
  return true;
}

export function TestIntegrationResponseFromJSON(
  json: any,
): TestIntegrationResponse {
  return TestIntegrationResponseFromJSONTyped(json, false);
}

export function TestIntegrationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TestIntegrationResponse {
  if (json == null) {
    return json;
  }
  return {
    ok: json["ok"],
    statusCode: json["statusCode"],
    responseBody: json["responseBody"],
  };
}

export function TestIntegrationResponseToJSON(
  json: any,
): TestIntegrationResponse {
  return TestIntegrationResponseToJSONTyped(json, false);
}

export function TestIntegrationResponseToJSONTyped(
  value?: TestIntegrationResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ok: value["ok"],
    statusCode: value["statusCode"],
    responseBody: value["responseBody"],
  };
}
